<template>
    <v-dialog v-model="dialog" max-width="400px" persistent  @keydown.esc="closeModal(false)">
        <v-card>
            <v-container>
                <div class="modal__container__div--Btn">
                    <v-btn class="modal__container__btn__close" color="#EE5D09" text @click="closeModal(false)">
                        <span class="modal__container__btn__close--span" > x </span>                    
                    </v-btn>
                </div>
                <v-card-title class="vcard_cardtitle">Ranking</v-card-title>
                <v-card-text v-if="rankingInfo && rankingInfo.gamification != undefined">
                    <v-row>
                        <v-col class="no-pd-t no-pd-b no-pd-r" cols="5">
                            <span class="vcard_cardtext_indicators ranking-color--bronze">Cadastro</span>
                        </v-col>
                        <v-col class="no-pd" cols="4">
                            <span class="vcard_cardtext_indicators ranking-color--silver">R${{rankingInfo.gamification.parameters.tiers[1].tierBound}}</span>
                        </v-col>
                        <v-col class="no-pd" cols="3">
                            <span class="vcard_cardtext_indicators ranking-color--gold">R${{rankingInfo.gamification.parameters.tiers[2].tierBound}}</span>
                        </v-col>
                    </v-row>
                    <div class="cardtext__divprogress d-flex flex-auto">
                        <div class="cardtext_divprogress__bronze"></div>
                        <div class="cardtext_divprogress__silver"></div>
                        <div class="cardtext_divprogress__gold"></div>
                    </div>
                    <v-row>
                        <v-col class="no-pd flex-col-center" cols="3">
                            <v-img class="cardtext_medal" :src="medalRankingObject.bronze"/>
                            <span class="cardtext_medaltitle">Bronze</span>
                            <span class="cardtext_medaldescription">R${{rankingInfo.gamification.parameters.tiers[0].tierBound}} = {{'1 ponto'}}</span>
                        </v-col>
                        <v-col class="no-pd flex-col-center" cols="5">
                            <v-img class="cardtext_medal" :src="medalRankingObject.silver"/>
                            <span class="cardtext_medaltitle">Prata</span>
                            <span class="cardtext_medaldescription">{{'R$' + rankingInfo.gamification.parameters.tiers[1].tierBound + ' = ' + rankingInfo.gamification.parameters.tiers[1].tierMultiplier + 'x'}}</span>
                        </v-col>
                        <v-col class="no-pd flex-col-center" cols="3">
                            <v-img class="cardtext_medal" :src="medalRankingObject.gold"/>
                            <span class="cardtext_medaltitle">Ouro</span>
                            <span class="cardtext_medaldescription">{{'R$' + rankingInfo.gamification.parameters.tiers[2].tierBound + ' = ' + rankingInfo.gamification.parameters.tiers[2].tierMultiplier + 'x'}}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" v-for="(bronzeRule, index) in tierRulesBronze" :key="'0' + index">
                            <span class="cardtext__info">
                                {{'• ' + bronzeRule}}
                            </span>
                        </v-col>
                        <v-col class="" cols="12" v-for="(silverRule, index) in tierRulesSilver" :key="'1' +index">
                            <span class="cardtext__info">
                                {{'• ' + silverRule}}
                            </span>
                        </v-col>
                        <v-col class="" cols="12" v-for="(goldRule, index) in tierRulesGold" :key=" '2' + index">
                            <span class="cardtext__info">
                                {{'• ' + goldRule}}
                            </span>
                        </v-col>
                        <v-col class="" cols="12" v-for="(rankingRule, index) in rankingRules" :key="'3'+index">
                            <span class="cardtext__info">
                                {{'• ' + rankingRule}}
                            </span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'rankingDetail',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        rankingInfo: {
            type: Object
        }
    },
    data: () => ({
        medalRankingObject: {
            bronze: require('@/assets/points-program/medal_bronze.svg'),
            silver: require('@/assets/points-program/medal_prata.svg'),
            gold: require('@/assets/points-program/medal_ouro.svg')
        },
        tierRulesBronze: [],
        tierRulesSilver: [],
        tierRulesGold: [],
        rankingRules: []
    }),
    watch: {
        rankingInfo: {
            deep: true,
            handler() {
                this.tierRulesBronze = this.rankingInfo.gamification.parameters.tiers[0].tierRules
                this.tierRulesSilver = this.rankingInfo.gamification.parameters.tiers[1].tierRules
                this.tierRulesGold = this.rankingInfo.gamification.parameters.tiers[2].tierRules
                this.rankingRules = this.rankingInfo.gamification.parameters.rankingRules
            }
        }
    },
    methods: {
        closeModal(condition) {
            this.$emit('rankingDetailModalClose', condition)
        },
    }
}
</script>

<style scoped>
.cardtext__divprogress {
    height: 24px;
    border: 1px solid black;
    border-radius: 12px;
    padding: 2px;
    margin-bottom: 10px;
}
.cardtext_divprogress__bronze {
    height: 18px;
    background-color: #8D7463;
    width: 45%;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
    margin-right: 2px;    
}
.cardtext_divprogress__silver {
    height: 18px;
    background-color: #C7C7C7;
    width: 35%;
    margin-right: 2px;
}
.cardtext_divprogress__gold {
    height: 18px;
    background-color: #FFD202;
    border-top-right-radius: 8px;
    width: 20%;
    border-bottom-right-radius: 8px;
}
.vcard_cardtitle{
    font-weight: 900;
    font-size: 26px;
}
.vcard_cardtext_indicators {
    font-size: 12px;
    font-weight: 600;
}
.cardtext_medaltitle {
    font-weight: 800;
    font-size: 13px;
    height: 16px;
}
.cardtext_medal {
    max-height: 35px;
    max-width: 35px;
}
.cardtext_medaldescription {
    font-size: 11px;
    color: var(--cor--cinza--escuro)
}
.cardtext__info {
    font-size: 16px;
    color: var(--cor--cinza--escuro)
}
.ranking-color--bronze {
    color: #8D7463;
}
.ranking-color--silver {
    color: #C7C7C7;
}
.ranking-color--gold {
    color : #FFD202;
}
::v-deep .v-dialog {
    border-radius: 12px !important;
}
</style>